import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import MxFormL3RushRadioDuoField from "@rf-l3/form/MxFormL3RushRadioDuo";
import { memo, useMemo } from "react";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { A_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import MxFormL3InputField from "@rf-l3/form/MxFormL3InputField";

import { usePropertyFormFeaturesState } from "../../../../store/slices/FormFeaturesSlice";
import usePropertyHelpTypeLocations from "../../../../hooks/helps/usePropertyHelpTypeLocations";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";
import usePropertyFormHelp from "../../../../hooks/helps/usePropertyFormHelp";
import { checkFeatureIndicator } from "../../../../util/model/feature-indicators";
import { checkFeatureIndicatorProject } from "../../../../util/model/feature-indicators";

const FeatureDateFormSection = () => {
  const { PROPERTY_TYPE_ID } = usePropertyFormHelp();
  const { forProject, forProperty } = usePropertyFormFeaturesState();
  const { isProject } = usePropertyHelpTypeLocations();
  const FEATURE = isProject ? forProject.unit : forProperty;

  const SHOW = useMemo(
    () => ({
      frames: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "frames")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "frames"),
      closets: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "closets")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "closets"),
      doors: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "doors")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "doors"),

      windows: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "windows")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "windows"),
      cabinets: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "cabinets")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "cabinets"),
      floors: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "floors")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "floors"),
      houseType: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "houseType")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "houseType"),

      roofForm: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "roofForm")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "roofForm"),

      roof: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "roof")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "roof"),

      tarea: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "tarea")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "tarea"),
      maintenance: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "maintenance")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "maintenance"),
      studio: isProject
        ? checkFeatureIndicatorProject(PROPERTY_TYPE_ID!, "studio")
        : checkFeatureIndicator(PROPERTY_TYPE_ID!, "studio")
    }),
    [PROPERTY_TYPE_ID]
  );

  if (
    !(
      SHOW.cabinets ||
      SHOW.closets ||
      SHOW.doors ||
      SHOW.floors ||
      SHOW.frames ||
      SHOW.houseType ||
      SHOW.maintenance ||
      SHOW.roof ||
      SHOW.roofForm ||
      SHOW.tarea ||
      SHOW.windows ||
      SHOW.studio
    )
  ) {
    return <div></div>;
  }

  return (
    <Grid container spacing={2}>
      <Grid container item xs={12}>
        <MxFormSubTitle label="Características" />
      </Grid>
      {SHOW.studio && (
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <MxFormL3RushRadioDuoField
            withreacthookform={1}
            name={CPropertyFormKeys.is_study_property}
            items={A_YES_AND_NOT}
            label="¿Es un Estudio?"
          />
        </Grid>
      )}

      {SHOW.frames && (
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.characteristics_frames_property}
            items={FEATURE?.frames ?? []}
            label="Marcos"
          />
        </Grid>
      )}

      {SHOW.closets && (
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.characteristics_closets_property}
            items={FEATURE?.closet ?? []}
            label="Closets"
          />
        </Grid>
      )}

      {SHOW.doors && (
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.characteristics_door_property}
            items={FEATURE?.doors ?? []}
            label="Puertas"
          />
        </Grid>
      )}

      {SHOW.roof && (
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.characteristics_roof_property}
            items={FEATURE?.roof ?? []}
            label="Techo"
          />
        </Grid>
      )}

      {SHOW.windows && (
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.characteristics_windows_property}
            items={FEATURE?.windows ?? []}
            label="Ventanas"
          />
        </Grid>
      )}

      {SHOW.cabinets && (
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.characteristics_cabinets_property}
            items={FEATURE?.cabinets ?? []}
            label="Gabinetes"
          />
        </Grid>
      )}

      {SHOW.floors && (
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.characteristics_floors_property}
            items={FEATURE?.floors ?? []}
            label="Pisos"
          />
        </Grid>
      )}

      {SHOW.houseType && (
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.characteristics_type_house_property}
            items={FEATURE?.houseType ?? []}
            label="Tipo de vivienda"
          />
        </Grid>
      )}

      {SHOW.roofForm && (
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.characteristics_roof_form_property}
            items={FEATURE?.roofForm ?? []}
            label="Tipo de techo"
          />
        </Grid>
      )}

      {SHOW.tarea && (
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <MxFormL3InputField
            withreacthookform={1}
            name={CPropertyFormKeys.tareas_property}
            label="Tareas"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default memo(FeatureDateFormSection);
